import React, { useEffect, useState } from "react";
import "./Services.css";
import Footer from "./Footer";
import Navbar from "./Navbar";

function Services() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMarqueePaused, setIsMarqueePaused] = useState(false);

  const marqueeRow1 = [
    "living-1.jpeg",
    "living-2.jpeg",
    "living-3.jpeg",
    "living-4.jpeg",
    "living-5.jpeg",
    "living-6.jpeg",
    "living-7.jpeg",
    "living-8.jpeg",
  ];

  const marqueeRow2 = [
    "bedroom-1.jpeg",
    "bedroom-2.jpeg",
    "bedroom-3.jpeg",
    "bedroom-4.jpeg",
    "bedroom-5.jpeg",
    "bedroom-6.jpeg",
    "bedroom-7.jpeg",
    "bedroom-8.jpeg",
  ];

  const heroSlides = [
    {
      image: "/Images/contact1.jpg",
      title: "Services",
      subtitle:
        "Premium interior design, modular kitchens, 3D planning, and clean execution for beautiful spaces.",
    },
    {
      image: "/Images/contact2.jpg",
      title: "Design That Feels Personal",
      subtitle:
        "We understand your space, your lifestyle, and your taste before creating the right interior plan.",
    },
    {
      image: "/Images/contact3.jpg",
      title: "From Idea To Handover",
      subtitle:
        "A clear process with practical planning, rich finishes, and smooth site execution.",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % heroSlides.length);
    }, 3500);

    return () => clearInterval(timer);
  }, [heroSlides.length]);

  const testimonialsServicesReviews = [
  {
    chip: "Finish",
    text: "The finishing looks premium and clean. Lighting and ceiling work was done neatly.",
    name: "Home Interior",
  },
  {
    chip: "Planning",
    text: "The 3D design helped us decide fast. Execution followed the plan without confusion.",
    name: "Modular Kitchen",
  },
  {
    chip: "On-Time",
    text: "Work was completed on time, and the team kept the site clean. Very professional.",
    name: "Full Home Project",
  },
  {
    chip: "Design",
    text: "They understood our taste clearly and gave a beautiful design that matched our home.",
    name: "Living Room Interior",
  },
  {
    chip: "Quality",
    text: "Material quality and finishing were better than expected. The final look felt very rich.",
    name: "Bedroom Interior",
  },
  {
    chip: "Support",
    text: "The team explained everything properly and guided us throughout the complete process.",
    name: "Apartment Interior",
  },
  {
    chip: "Execution",
    text: "Site work was handled smoothly with proper coordination and clean finishing.",
    name: "Villa Project",
  },
  {
    chip: "Premium",
    text: "The space now feels elegant, modern, and well planned. We are happy with the result.",
    name: "Complete Interior",
  },
];

const [activeFaqServices, setActiveFaqServices] = useState(null);

const faqServicesItems = [
  {
    question: "Do you provide 3D design before work starts?",
    answer: "Yes. We share 3D views and finalize the design before starting the execution work.",
  },
  {
    question: "Which areas do you take projects in?",
    answer: "We take projects in Andhra Pradesh, Telangana, Karnataka, Odisha, and selected locations across India.",
  },
  {
    question: "How do I get a quote?",
    answer: "You can call us or contact us through the enquiry page. A site visit helps us give a more accurate quote.",
  },
  {
    question: "Do you handle modular kitchens?",
    answer: "Yes. We handle modular kitchen design, storage planning, material selection, and installation.",
  },
  {
    question: "Do you provide complete home interiors?",
    answer: "Yes. We work on complete home interiors including living rooms, bedrooms, kitchens, ceilings, wardrobes, and decor.",
  },
  {
    question: "Can you work based on my budget?",
    answer: "Yes. We understand your budget first and suggest the best practical design and material options.",
  },
  {
    question: "Do you help with material selection?",
    answer: "Yes. We guide you with laminates, colors, finishes, lighting, hardware, and other interior materials.",
  },
  {
    question: "How long does an interior project take?",
    answer: "The timeline depends on the size and scope of work. After the site visit and design finalization, we share a clear schedule.",
  },
];


  return (
    <div>
      <Navbar />

      <div className="services-wrapper" id="services">
        <section className="contact8-hero-services" aria-label="Contact hero slideshow">
          {heroSlides.map((slide, index) => (
            <div
              className={`contact8-hero-slide-services ${activeSlide === index ? "active-services" : ""
                }`}
              key={slide.image}
            >
              <img
                className="contact8-hero-img-services"
                src={slide.image}
                alt={slide.title}
              />
            </div>
          ))}

          <div className="contact8-hero-overlay-services" />

          <div className="contact8-hero-content-services">

            <h1 className="contact8-hero-title-services">
              {heroSlides[activeSlide].title}
            </h1>

            <p className="contact8-hero-sub-services">
              {heroSlides[activeSlide].subtitle}
            </p>

            <div
              className="contact8-hero-badges-services"
              aria-label="Service regions"
            >
              <span className="contact8-badge-services">Andhra Pradesh</span>
              <span className="contact8-badge-services">Telangana</span>
              <span className="contact8-badge-services">Karnataka</span>
              <span className="contact8-badge-services">Odisha</span>
              <span className="contact8-badge-services">Expanding Across India</span>
            </div>

            <div
              className="contact8-slide-dots-services"
              aria-label="Hero slideshow controls"
            >
              {heroSlides.map((slide, index) => (
                <button
                  type="button"
                  key={slide.image}
                  className={`contact8-slide-dot-services ${activeSlide === index ? "active-services" : ""
                    }`}
                  aria-label={`Show slide ${index + 1}`}
                  onClick={() => setActiveSlide(index)}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="brandstrip" aria-label="Brand intro">
          <div className="brandstrip-inner">
            <div className="brandstrip-left">
              <h2 className="section-title">INCHX Signature Work</h2>
              <div className="section-underline" />
              <p className="section-sub">
                We design interiors that feel premium, practical, and calm. From the first 3D view to the final finish,
                everything stays clean, aligned, and on-time.
              </p>

              <div className="brandstrip-points">
                <div className="brandstrip-point">
                  <span className="pill">Design First</span>
                  <div className="brandstrip-point-text">Clear planning with 3D design before execution begins.</div>
                </div>
                <div className="brandstrip-point">
                  <span className="pill">Neat Finish</span>
                  <div className="brandstrip-point-text">Clean edges, balanced lighting, and smooth handovers.</div>
                </div>
                <div className="brandstrip-point">
                  <span className="pill">Execution</span>
                  <div className="brandstrip-point-text">Step-by-step tracking and quality checks throughout.</div>
                </div>
              </div>
            </div>

            <div className="brandstrip-right" aria-label="Brand images">
              <div className="brandstrip-gallery">
                <figure className="imgcard">
                  <img src="/Images/own/house1.jpeg" alt="Interior finish" />
                </figure>
                <figure className="imgcard">
                  <img src="/Images/own/house2.jpeg" alt="Premium detailing" />
                </figure>
                <figure className="imgcard">
                  <img src="/Images/own/featured.jpeg" alt="Featured interior" />
                </figure>
                <figure className="imgcard">
                  <img src="/Images/own/clock2.jpeg" alt="Theme and mood" />
                </figure>
              </div>
            </div>
          </div>
        </section>

        <section className="svcgrid" aria-label="Services">
          <div className="svcgrid-inner">
            <header className="section-head">
              <h2 className="section-title">Our Services</h2>
              <div className="section-underline" />
              <p className="section-sub">
                Full-service interior and facade work, with design clarity and execution discipline.
              </p>
            </header>

            <div className="svcgrid-grid">
              <article className="svcgrid-card">
                <div className="svcgrid-icon">01</div>
                <h3 className="svcgrid-title">Interior Designing</h3>
                <p className="svcgrid-text">
                  Space planning, layout design, and material selection to match your style and budget.
                </p>
              </article>

              <article className="svcgrid-card">
                <div className="svcgrid-icon">02</div>
                <h3 className="svcgrid-title">3D Designing</h3>
                <p className="svcgrid-text">
                  See your home before work starts. Clean 3D views with practical sizing and lighting ideas.
                </p>
              </article>

              <article className="svcgrid-card">
                <div className="svcgrid-icon">03</div>
                <h3 className="svcgrid-title">Modular Kitchens</h3>
                <p className="svcgrid-text">
                  Smart storage, neat shutters, durable hardware, and a finish built for daily use.
                </p>
              </article>

              <article className="svcgrid-card">
                <div className="svcgrid-icon">04</div>
                <h3 className="svcgrid-title">Planning & Execution</h3>
                <p className="svcgrid-text">
                  Timelines, tracking, and smooth coordination so the project stays on time and clean.
                </p>
              </article>

              <article className="svcgrid-card">
                <div className="svcgrid-icon">05</div>
                <h3 className="svcgrid-title">Facade Designing</h3>
                <p className="svcgrid-text">
                  Modern elevation concepts with balanced lines, textures, and long-lasting materials.
                </p>
              </article>

              
            </div>
          </div>
        </section>

        {/*<section className="process" aria-label="Process">
          <div className="process-inner">
            <header className="section-head section-head-dark">
              <h2 className="section-title section-title-dark">How We Work</h2>
              <div className="section-underline" />
              <p className="section-sub section-sub-dark">
                Simple steps, clear communication, and finishing that feels premium.
              </p>
            </header>

            <div className="process-grid">
              <div className="process-step">
                <div className="process-no">01</div>
                <div className="process-body">
                  <div className="process-title">Site Visit</div>
                  <div className="process-text">Measurements, requirements, and style direction.</div>
                </div>
              </div>

              <div className="process-step">
                <div className="process-no">02</div>
                <div className="process-body">
                  <div className="process-title">3D Design</div>
                  <div className="process-text">Layouts, elevations, lighting, and mood selection.</div>
                </div>
              </div>

              <div className="process-step">
                <div className="process-no">03</div>
                <div className="process-body">
                  <div className="process-title">Quotation</div>
                  <div className="process-text">Clear scope, transparent pricing, and timelines.</div>
                </div>
              </div>

              <div className="process-step">
                <div className="process-no">04</div>
                <div className="process-body">
                  <div className="process-title">Execution</div>
                  <div className="process-text">Neat work, quality checks, and regular updates.</div>
                </div>
              </div>

              <div className="process-step">
                <div className="process-no">05</div>
                <div className="process-body">
                  <div className="process-title">Handover</div>
                  <div className="process-text">Clean finish, final walk-through, and support.</div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/*<section className="regions" aria-label="Regions we serve">
  <div className="regions-inner">
    <div className="regions-grid">
      <div className="regions-left">
        <h2 className="section-title">Regions We Serve</h2>
        <div className="section-underline" />
        <p className="section-sub">
          We take projects across South India with the same finish standard and execution discipline.
        </p>

        <div className="regions-cards">
          <div className="regions-card">
            <div className="regions-card-title">Andhra Pradesh</div>
            <div className="regions-card-sub">Homes, apartments, and elevations.</div>
          </div>

          <div className="regions-card">
            <div className="regions-card-title">Telangana</div>
            <div className="regions-card-sub">Modern interiors and modular works.</div>
          </div>

          <div className="regions-card">
            <div className="regions-card-title">Karnataka</div>
            <div className="regions-card-sub">Planned execution with premium finish.</div>
          </div>

          <div className="regions-card">
            <div className="regions-card-title">Odisha</div>
            <div className="regions-card-sub">Elegant interior solutions with trusted execution.</div>
          </div>
        </div>
      </div>

      <div className="regions-right" aria-label="Regions visuals">
        <div className="regions-visual">
          <img src="/Images/own/house1.jpeg" alt="Exterior showcase" />
          <div className="regions-float">
            <div className="regions-float-title">Book a Site Visit</div>
            <div className="regions-float-sub">Call +91 9393141224</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> */}

        <section className="featured" aria-label="Featured highlights">
          <div className="featured-inner">
            <header className="section-head">
              <h2 className="section-title">Featured Highlights</h2>
              <div className="section-underline" />
              <p className="section-sub">A few signature finishes that clients love, clean, modern, and long-lasting.</p>
            </header>

            <div className="featured-grid">
              <article className="featured-card">
                <img src="/Images/own/house1.jpeg" alt="Lighting and ceiling finish" />
                <div className="featured-cap">
                  <div className="featured-cap-title">Ceiling & Lighting</div>
                  <div className="featured-cap-sub">Balanced light, neat finishing.</div>
                </div>
              </article>

              <article className="featured-card">
                <img src="/Images/grid2.jpg" alt="Modular kitchen finish" />
                <div className="featured-cap">
                  <div className="featured-cap-title">Modular Kitchen</div>
                  <div className="featured-cap-sub">Storage-first layouts.</div>
                </div>
              </article>

              <article className="featured-card">
                <img src="/Images/grid3.jpg" alt="Wardrobes and storage" />
                <div className="featured-cap">
                  <div className="featured-cap-title">Wardrobes & Storage</div>
                  <div className="featured-cap-sub">Smooth finish, clean lines.</div>
                </div>
              </article>

              <article className="featured-card">
                <img src="/Images/grid4.jpg" alt="Living room finishes" />
                <div className="featured-cap">
                  <div className="featured-cap-title">Living Spaces</div>
                  <div className="featured-cap-sub">Calm tones, practical planning.</div>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className="marquee" aria-label="Animated gallery">
  <div className="marquee-inner">
    <header className="section-head section-head-dark">
      <h2 className="section-title section-title-dark">Services Gallery</h2>
      <div className="section-underline" />
    </header>

    <div
      className={`marquee-wrap ${isMarqueePaused ? "marquee-paused" : ""}`}
      onClick={() => setIsMarqueePaused((prev) => !prev)}
    >
      <div className="marquee-row marquee-row-a" aria-hidden="true">
        {[...marqueeRow1, ...marqueeRow1].map((img, idx) => (
          <div className="marquee-card" key={`a-${idx}`}>
            <img src={`/Images/own/${img}`} alt="" />
          </div>
        ))}
      </div>

      <div className="marquee-row marquee-row-b" aria-hidden="true">
        {[...marqueeRow2, ...marqueeRow2].map((img, idx) => (
          <div className="marquee-card" key={`b-${idx}`}>
            <img src={`/Images/own/${img}`} alt="" />
          </div>
        ))}
      </div>
    </div>

    <div className="marquee-cta">
      <a className="btn btn-solid" href="/contact">
        Get a Design Plan
      </a>
      <a className="btn btn-outline" href="tel:+919393141224">
        Talk to Us
      </a>
    </div>
  </div>
</section>

        {/*<section className="showcase" aria-label="Project showcase">
          <div className="showcase-inner">
            <header className="section-head">
              <h2 className="section-title">Project Showcase</h2>
              <div className="section-underline" />
              <p className="section-sub">
                Strong planning, neat execution, and a finish that feels premium and calm.
              </p>
            </header>

            <div className="showcase-grid">
              <div className="showcase-left">
                <article className="showcase-hero">
                  <img
                    src="/Images/contact3.jpg"
                    alt="Modern interior showcase"
                  />
                  <div className="showcase-hero-overlay" />
                  <div className="showcase-hero-cap">
                    <div className="showcase-hero-kicker">INCHX INTERIO</div>
                    <div className="showcase-hero-title">Modern Homes, Made Practical</div>
                    <div className="showcase-hero-sub">Neat detailing, balanced layouts, and clean finishing.</div>
                  </div>
                </article>

                <div className="showcase-tiles">
                  <article className="showcase-tile">
                    <img src="/Images/interior2.jpg" alt="Premium interior" />
                    <div className="showcase-tile-cap">
                      <div className="showcase-tile-title">Premium Interiors</div>
                    </div>
                  </article>

                  <article className="showcase-tile">
                    <img src="/Images/clock2.jpg" alt="Smart layout planning" />
                    <div className="showcase-tile-cap">
                      <div className="showcase-tile-title">Smart Layout Planning</div>
                    </div>
                  </article>
                </div>
              </div>

              <aside className="showcase-right" aria-label="Showcase highlights">
                <div className="showcase-panel">
                  <h3 className="showcase-panel-title">What You Can Expect</h3>
                  <p className="showcase-panel-text">
                    Clean planning and clean finishing. From the first layout to the final touch, every step stays aligned
                    and tracked.
                  </p>

                  <ul className="showcase-points">
                    <li>
                      <span className="bullet" />
                      Modern elevation and clean lines
                    </li>
                    <li>
                      <span className="bullet" />
                      Quality materials with neat detailing
                    </li>
                    <li>
                      <span className="bullet" />
                      Lighting and storage planned for daily living
                    </li>
                    <li>
                      <span className="bullet" />
                      Timely delivery with regular updates
                    </li>
                    <li>
                      <span className="bullet" />
                      Friendly support after handover
                    </li>
                  </ul>

                  <div className="showcase-actions">
                    <a className="btn btn-solid" href="/contact">
                      Get Quote
                    </a>
                    <a className="btn btn-outline" href="tel:+919393141224">
                      Call Now
                    </a>
                  </div>

                  <div className="showcase-meta">
                    <div className="showcase-meta-title">Andhra Pradesh • Telangana • Karnataka</div>
                    <div className="showcase-meta-sub">
                      <a className="link" href="tel:+919393141224">
                        +91 9393141224
                      </a>
                      <span className="sep">|</span>
                      <a className="link" href="mailto:inchxinterio@gmail.com">
                        inchxinterio@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section> */}

        <section className="testimonials-services" aria-label="Testimonials">
  <div className="testimonials-inner-services">
    <header className="section-head-services section-head-dark-services">
      <h2 className="section-title-services1 section-title-dark-services">
        Client Words
      </h2>
      <div className="section-underline-services1" />
      <p className="section-sub-services1 section-sub-dark-services">
        Short feedback that reflects what we focus on, finish, clarity, and on-time execution.
      </p>
    </header>

    <div className="testimonials-marquee-services">
      <div className="testimonials-track-services">
        {[...testimonialsServicesReviews, ...testimonialsServicesReviews].map((review, index) => (
          <article className="tcard-services" key={`${review.name}-${index}`}>
            <div className="tcard-top-services">
              <div className="tchip-services">{review.chip}</div>
              <div className="tstars-services">★★★★★</div>
            </div>
            <p className="ttext-services">{review.text}</p>
            <div className="tname-services">{review.name}</div>
          </article>
        ))}
      </div>
    </div>
  </div>
</section>

        <section className="faq-services" aria-label="FAQ">
  <div className="faq-inner-services">
    <header className="section-head-services">
      <div className="faq-kicker-services">FAQ</div>
      <h2 className="section-title-services">Quick Answers</h2>
      <div className="section-underline-services" />
      <p className="section-sub-services">
        A few common questions before you book a site visit.
      </p>
    </header>

    <div className="faq-grid-services">
      {faqServicesItems.map((item, index) => (
        <div
          className={`faq-item-services ${
            activeFaqServices === index ? "active-services" : ""
          }`}
          key={item.question}
        >
          <button
            type="button"
            className="faq-question-btn-services"
            onClick={() =>
              setActiveFaqServices(activeFaqServices === index ? null : index)
            }
            aria-expanded={activeFaqServices === index}
          >
            <span className="faq-q-services">{item.question}</span>
            <span className="faq-icon-services">
              {activeFaqServices === index ? "−" : "+"}
            </span>
          </button>

          <div className="faq-answer-wrap-services">
            <div className="faq-a-services">{item.answer}</div>
          </div>
        </div>
      ))}
    </div>

    <div className="faq-cta-services">
      <a className="btn-services btn-solid-services" href="/contact">
        Enquire Now
      </a>
      <a
        className="btn-services btn-outline-services"
        href="mailto:inchxinterio@gmail.com"
      >
        Email Us
      </a>
    </div>
  </div>
</section>

        {/*<section className="cta" aria-label="Final call to action">
          <div className="cta-inner">
            <div className="cta-panel">
              <div className="cta-left">
                <div className="cta-kicker">KALKINADH ONENESS (KANNA)</div>
                <h2 className="cta-title">Ready to start your interior work?</h2>
                <p className="cta-sub">
                  Share your requirement, we will guide you with planning, finishes, and a clean execution timeline.
                </p>
                <div className="cta-actions">
                  <a className="btn btn-solid" href="/contact">
                    Get Quote
                  </a>
                  <a className="btn btn-outline" href="tel:+919393141224">
                    Call +91 9393141224
                  </a>
                </div>
              </div>

              <div className="cta-right">
                <img src="/Images/right1.jpg" alt="Interior preview" />
              </div>
            </div>
          </div>
        </section> */}

        <Footer />
      </div>
    </div>
  );
}

export default Services;